"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ErrorOutlineRounded_1 = require("@material-ui/icons/ErrorOutlineRounded");
const ReportProblemOutlined_1 = require("@material-ui/icons/ReportProblemOutlined");
const React = require("react");
const HelperText = ({ helperText, isError, id }) => {
    const [isMounted, setIsMounted] = React.useState(false);
    React.useEffect(() => {
        setIsMounted(true);
    }, []);
    if (!helperText)
        return null;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isError ? (0, jsx_runtime_1.jsx)(ReportProblemOutlined_1.default, { fontSize: "small" }) : (0, jsx_runtime_1.jsx)(ErrorOutlineRounded_1.default, { fontSize: "small" }), (0, jsx_runtime_1.jsx)("span", Object.assign({ id: id }, (isError && { role: 'alert' }), { children: helperText }))] }));
};
exports.default = HelperText;
//# sourceMappingURL=HelperText.js.map